export default __webpack_public_path__ + "static/media/Magadhi_health_m.268162c8.wav";